import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import editIcon from "../../../assets/images/Edit.svg";
import viewIcon from "../../../assets/images/View.svg";
import { MuiDataGridStyle } from "../../../theme/App.theme";
import NoRecordsToDisplay from "../../../components/CommonReusableComponent/NoRecordsToDisplay/NoRecordsToDisplay";

const AuditTypeMasterDataTable_V2 = ({
  Rows,
  GetRowDataOnClickOfAction,
  PageSizeOptions,
  RowsToDisplay,
}) => {
  const Columns = [
    {
      field: "action",
      headerName: "Action",
      headerAlign: "center",
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      minWidth: 90,
      maxWidth: 90,
      renderCell: (param) => (
        <div className="d-flex justify-content-center align-items-center h-100 gap-3">
          <img
            src={viewIcon}
            className="cursor-pointer"
            alt={"View"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction(
                "View Audit Type",
                param.row,
                "/audit-type-master/view"
              );
            }}
          />
          <img
            src={editIcon}
            className="cursor-pointer"
            alt={"Edit"}
            style={{ width: "20px", height: "20px" }}
            onClick={() => {
              GetRowDataOnClickOfAction(
                "Update Audit Type",
                param.row,
                "/audit-type-master/update"
              );
            }}
          />
        </div>
      ),
    },
    {
      field: "name",
      headerName: "Audit Type",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "auditTypeCategoryName",
      headerName: "Audit Type Category",
      flex: 1,
      minWidth: 150,
    },
    {
      field: "abbreviation",
      headerName: "Unique Prefix",
      sortable: false,
      flex: 1,
      maxWidth: 250,
      minWidth: 150,
    },
  ];

  return (
    <React.Fragment>
      <div className="w-100">
        <DataGrid
          columns={Columns}
          rows={Rows}
          slots={{
            noRowsOverlay: NoRecordsToDisplay,
          }}
          pageSizeOptions={PageSizeOptions || [5, 10, 15, 25, 50]}
          initialState={{
            density: "compact",
            pagination: {
              paginationModel: {
                pageSize: RowsToDisplay || 10,
              },
            },
          }}
          disableRowSelectionOnClick
          density="compact"
          className="custom-data-grid"
          sx={MuiDataGridStyle}
        />
      </div>
    </React.Fragment>
  );
};

export default AuditTypeMasterDataTable_V2;
